import { LoadingAnimation } from "widgets";

export const TableLoadingOverlay = () => {
  return (
    <div role="presentation">
      <LoadingAnimation />
    </div>
  );
};
